import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <section className='header_section'>
        <Navbar
          expand="lg"
          expanded={expanded}  // control expansion manually
          className=""
          onToggle={() => setExpanded(!expanded)}  // toggle when hamburger clicked
        >
          <div className="container">
            <Navbar.Brand as={Link} to={"/"} onClick={() => setExpanded(false)}>
              <img className="logo-img" src={process.env.PUBLIC_URL + '/assets/images/logo/logo.png'} alt="logo-img" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link
                  as={Link}
                  to={"/"}
                  className={location.pathname === "/" ? "active" : ""}
                  onClick={() => setExpanded(false)} // close menu after click
                >
                  HOME
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/about-us"}
                  className={location.pathname === "/about-us" ? "active" : ""}
                  onClick={() => setExpanded(false)}
                >
                  ABOUT US
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/all-products"}
                  className={location.pathname === "/all-products" ? "active" : ""}
                  onClick={() => setExpanded(false)}
                >
                  PRODUCTS
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to={"/contact-us"}
                  className={location.pathname === "/contact-us" ? "active" : ""}
                  onClick={() => setExpanded(false)}
                >
                  CONTACT US
                </Nav.Link>

              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
